module.exports = __webpack_public_path__ + "static/img/achievments.270cd27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/achievments.jpg
// module id = g9Ys
// module chunks = 0